var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeatures3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 640 640",
    width: 640,
    height: 640,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.91 484.85L638.06 484.85L638.06 2.91L2.91 2.91L2.91 484.85ZM623.52 108.61L17.45 108.61L17.45 17.45L623.52 17.45L623.52 108.61ZM17.45 470.3L17.45 122.18L623.52 122.18L623.52 469.33L17.45 469.33L17.45 470.3Z",
    id: "bJLys9HhF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.24 63.03C600.24 45.58 586.67 32 569.21 32C551.76 32 538.18 45.58 538.18 63.03C538.18 80.48 551.76 94.06 569.21 94.06C586.67 94.06 600.24 80.48 600.24 63.03ZM585.7 64C585.7 72.73 577.94 80.48 569.21 80.48C560.48 80.48 552.73 72.73 552.73 64C552.73 55.27 560.48 47.52 569.21 47.52C577.94 47.52 585.7 55.27 585.7 64Z",
    id: "b6nVrKTSeu"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.91 63.03C514.91 45.58 501.33 32 483.88 32C466.42 32 452.85 45.58 452.85 63.03C452.85 80.48 467.39 94.06 483.88 94.06C501.33 94.06 514.91 80.48 514.91 63.03ZM500.36 64C500.36 72.73 492.61 80.48 483.88 80.48C475.15 80.48 467.39 72.73 467.39 64C467.39 55.27 475.15 47.52 483.88 47.52C492.61 47.52 500.36 55.27 500.36 64Z",
    id: "btYigjvPu"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.55 94.06C416 94.06 429.58 80.48 430.55 64C431.52 46.55 417.94 32.97 400.48 32C383.03 32 369.45 44.61 368.48 62.06C367.52 79.52 381.09 94.06 398.55 94.06C398.55 94.06 398.55 94.06 398.55 94.06ZM416 64C416 72.73 408.24 79.52 399.52 79.52C390.79 79.52 383.03 71.76 384 63.03C383.03 54.3 390.79 47.52 399.52 47.52C409.21 47.52 416 55.27 416 64Z",
    id: "a2l5mW96it"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.76 56.24C263.76 56.24 263.76 56.24 263.76 56.24C263.76 64.97 263.76 69.82 263.76 70.79C263.76 70.79 263.76 70.79 263.76 70.79C133.43 70.79 61.03 70.79 46.55 70.79C46.55 70.79 46.55 70.79 46.55 70.79C46.55 62.06 46.55 57.21 46.55 56.24C46.55 56.24 46.55 56.24 46.55 56.24C176.87 56.24 249.28 56.24 263.76 56.24Z",
    id: "c39SpFgxrA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.58 294.79L147.39 396.61L158.06 385.94L65.94 294.79L158.06 203.64L147.39 193.94L45.58 294.79Z",
    id: "bEpse2bm9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.06 294.79L481.94 385.94L492.61 396.61L594.42 294.79L492.61 193.94L481.94 203.64L574.06 294.79Z",
    id: "aALNm2hVQ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.85 235.64C260.85 235.64 260.85 235.64 260.85 235.64C260.85 244.36 260.85 249.21 260.85 250.18C260.85 250.18 260.85 250.18 260.85 250.18C202.08 250.18 169.44 250.18 162.91 250.18C162.91 250.18 162.91 250.18 162.91 250.18C162.91 241.45 162.91 236.61 162.91 235.64C162.91 235.64 162.91 235.64 162.91 235.64C221.67 235.64 254.32 235.64 260.85 235.64Z",
    id: "d1xPb7qdj7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.21 235.64C345.21 235.64 345.21 235.64 345.21 235.64C345.21 244.36 345.21 249.21 345.21 250.18C345.21 250.18 345.21 250.18 345.21 250.18C310.88 250.18 291.81 250.18 288 250.18C288 250.18 288 250.18 288 250.18C288 241.45 288 236.61 288 235.64C288 235.64 288 235.64 288 235.64C322.33 235.64 341.4 235.64 345.21 235.64Z",
    id: "e9bBF0baz"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416 235.64C416 235.64 416 235.64 416 235.64C416 244.36 416 249.21 416 250.18C416 250.18 416 250.18 416 250.18C387.49 250.18 371.65 250.18 368.48 250.18C368.48 250.18 368.48 250.18 368.48 250.18C368.48 241.45 368.48 236.61 368.48 235.64C368.48 235.64 368.48 235.64 368.48 235.64C396.99 235.64 412.83 235.64 416 235.64Z",
    id: "b3DrgH6qBd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.06 235.64C478.06 235.64 478.06 235.64 478.06 235.64C478.06 244.36 478.06 249.21 478.06 250.18C478.06 250.18 478.06 250.18 478.06 250.18C457.7 250.18 446.38 250.18 444.12 250.18C444.12 250.18 444.12 250.18 444.12 250.18C444.12 241.45 444.12 236.61 444.12 235.64C444.12 235.64 444.12 235.64 444.12 235.64C464.48 235.64 475.8 235.64 478.06 235.64Z",
    id: "df2OInyQy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.27 288C183.27 288 183.27 288 183.27 288C183.27 296.73 183.27 301.58 183.27 302.55C183.27 302.55 183.27 302.55 183.27 302.55C171.05 302.55 164.27 302.55 162.91 302.55C162.91 302.55 162.91 302.55 162.91 302.55C162.91 293.82 162.91 288.97 162.91 288C162.91 288 162.91 288 162.91 288C175.13 288 181.92 288 183.27 288Z",
    id: "b2ErcfWHv"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.42 288C306.42 288 306.42 288 306.42 288C306.42 296.73 306.42 301.58 306.42 302.55C306.42 302.55 306.42 302.55 306.42 302.55C248.82 302.55 216.82 302.55 210.42 302.55C210.42 302.55 210.42 302.55 210.42 302.55C210.42 293.82 210.42 288.97 210.42 288C210.42 288 210.42 288 210.42 288C268.02 288 300.02 288 306.42 288Z",
    id: "eOBLKPuP1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.61 288C396.61 288 396.61 288 396.61 288C396.61 296.73 396.61 301.58 396.61 302.55C396.61 302.55 396.61 302.55 396.61 302.55C356.46 302.55 334.16 302.55 329.7 302.55C329.7 302.55 329.7 302.55 329.7 302.55C329.7 293.82 329.7 288.97 329.7 288C329.7 288 329.7 288 329.7 288C369.84 288 392.15 288 396.61 288Z",
    id: "a3KCCeju0Y"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.06 288C478.06 288 478.06 288 478.06 288C478.06 296.73 478.06 301.58 478.06 302.55C478.06 302.55 478.06 302.55 478.06 302.55C446.06 302.55 428.28 302.55 424.73 302.55C424.73 302.55 424.73 302.55 424.73 302.55C424.73 293.82 424.73 288.97 424.73 288C424.73 288 424.73 288 424.73 288C456.73 288 474.51 288 478.06 288Z",
    id: "c1oT3pAiMH"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.45 339.39C241.45 339.39 241.45 339.39 241.45 339.39C241.45 348.12 241.45 352.97 241.45 353.94C241.45 353.94 241.45 353.94 241.45 353.94C194.33 353.94 168.15 353.94 162.91 353.94C162.91 353.94 162.91 353.94 162.91 353.94C162.91 345.21 162.91 340.36 162.91 339.39C162.91 339.39 162.91 339.39 162.91 339.39C210.04 339.39 236.22 339.39 241.45 339.39Z",
    id: "a3liNnorv"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.61 339.39C364.61 339.39 364.61 339.39 364.61 339.39C364.61 348.12 364.61 352.97 364.61 353.94C364.61 353.94 364.61 353.94 364.61 353.94C307.01 353.94 275.01 353.94 268.61 353.94C268.61 353.94 268.61 353.94 268.61 353.94C268.61 345.21 268.61 340.36 268.61 339.39C268.61 339.39 268.61 339.39 268.61 339.39C326.21 339.39 358.21 339.39 364.61 339.39Z",
    id: "cGDciW569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.39 339.39C435.39 339.39 435.39 339.39 435.39 339.39C435.39 348.12 435.39 352.97 435.39 353.94C435.39 353.94 435.39 353.94 435.39 353.94C406.88 353.94 391.05 353.94 387.88 353.94C387.88 353.94 387.88 353.94 387.88 353.94C387.88 345.21 387.88 340.36 387.88 339.39C387.88 339.39 387.88 339.39 387.88 339.39C416.39 339.39 432.23 339.39 435.39 339.39Z",
    id: "b3SUCSZLE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.06 339.39C478.06 339.39 478.06 339.39 478.06 339.39C478.06 348.12 478.06 352.97 478.06 353.94C478.06 353.94 478.06 353.94 478.06 353.94C469.33 353.94 464.48 353.94 463.52 353.94C463.52 353.94 463.52 353.94 463.52 353.94C463.52 345.21 463.52 340.36 463.52 339.39C463.52 339.39 463.52 339.39 463.52 339.39C472.24 339.39 477.09 339.39 478.06 339.39Z",
    id: "f4B8mwslqD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.48 638.06L592.48 495.52L39.76 495.52L39.76 638.06L592.48 638.06ZM577.94 510.06L577.94 622.55L54.3 622.55L54.3 510.06L577.94 510.06Z",
    id: "a1XuLLcX5J"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.03 523.64C95.03 523.64 95.03 523.64 95.03 523.64C95.03 532.36 95.03 537.21 95.03 538.18C95.03 538.18 95.03 538.18 95.03 538.18C81.65 538.18 74.21 538.18 72.73 538.18C72.73 538.18 72.73 538.18 72.73 538.18C72.73 529.45 72.73 524.61 72.73 523.64C72.73 523.64 72.73 523.64 72.73 523.64C86.11 523.64 93.54 523.64 95.03 523.64Z",
    id: "a4AKAZO1MJ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.42 523.64C146.42 523.64 146.42 523.64 146.42 523.64C146.42 532.36 146.42 537.21 146.42 538.18C146.42 538.18 146.42 538.18 146.42 538.18C133.04 538.18 125.61 538.18 124.12 538.18C124.12 538.18 124.12 538.18 124.12 538.18C124.12 529.45 124.12 524.61 124.12 523.64C124.12 523.64 124.12 523.64 124.12 523.64C137.5 523.64 144.94 523.64 146.42 523.64Z",
    id: "a5dRLWWBr"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.79 523.64C198.79 523.64 198.79 523.64 198.79 523.64C198.79 532.36 198.79 537.21 198.79 538.18C198.79 538.18 198.79 538.18 198.79 538.18C185.41 538.18 177.97 538.18 176.48 538.18C176.48 538.18 176.48 538.18 176.48 538.18C176.48 529.45 176.48 524.61 176.48 523.64C176.48 523.64 176.48 523.64 176.48 523.64C189.87 523.64 197.3 523.64 198.79 523.64Z",
    id: "a7suplbQ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.18 523.64C250.18 523.64 250.18 523.64 250.18 523.64C250.18 532.36 250.18 537.21 250.18 538.18C250.18 538.18 250.18 538.18 250.18 538.18C236.8 538.18 229.37 538.18 227.88 538.18C227.88 538.18 227.88 538.18 227.88 538.18C227.88 529.45 227.88 524.61 227.88 523.64C227.88 523.64 227.88 523.64 227.88 523.64C241.26 523.64 248.69 523.64 250.18 523.64Z",
    id: "c2JvyRf7iv"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.58 523.64C301.58 523.64 301.58 523.64 301.58 523.64C301.58 532.36 301.58 537.21 301.58 538.18C301.58 538.18 301.58 538.18 301.58 538.18C288.19 538.18 280.76 538.18 279.27 538.18C279.27 538.18 279.27 538.18 279.27 538.18C279.27 529.45 279.27 524.61 279.27 523.64C279.27 523.64 279.27 523.64 279.27 523.64C292.65 523.64 300.09 523.64 301.58 523.64Z",
    id: "b3xn1uhRQE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.94 523.64C353.94 523.64 353.94 523.64 353.94 523.64C353.94 532.36 353.94 537.21 353.94 538.18C353.94 538.18 353.94 538.18 353.94 538.18C340.56 538.18 333.12 538.18 331.64 538.18C331.64 538.18 331.64 538.18 331.64 538.18C331.64 529.45 331.64 524.61 331.64 523.64C331.64 523.64 331.64 523.64 331.64 523.64C345.02 523.64 352.45 523.64 353.94 523.64Z",
    id: "a1iuHSY2Ng"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.03 595.39C95.03 595.39 95.03 595.39 95.03 595.39C95.03 604.12 95.03 608.97 95.03 609.94C95.03 609.94 95.03 609.94 95.03 609.94C81.65 609.94 74.21 609.94 72.73 609.94C72.73 609.94 72.73 609.94 72.73 609.94C72.73 601.21 72.73 596.36 72.73 595.39C72.73 595.39 72.73 595.39 72.73 595.39C86.11 595.39 93.54 595.39 95.03 595.39Z",
    id: "e299QRzG69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.73 523.64C456.73 523.64 456.73 523.64 456.73 523.64C456.73 532.36 456.73 537.21 456.73 538.18C456.73 538.18 456.73 538.18 456.73 538.18C443.35 538.18 435.91 538.18 434.42 538.18C434.42 538.18 434.42 538.18 434.42 538.18C434.42 529.45 434.42 524.61 434.42 523.64C434.42 523.64 434.42 523.64 434.42 523.64C447.81 523.64 455.24 523.64 456.73 523.64Z",
    id: "b1l7vNqVMC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.48 523.64C560.48 523.64 560.48 523.64 560.48 523.64C560.48 532.36 560.48 537.21 560.48 538.18C560.48 538.18 560.48 538.18 560.48 538.18C547.1 538.18 539.67 538.18 538.18 538.18C538.18 538.18 538.18 538.18 538.18 538.18C538.18 529.45 538.18 524.61 538.18 523.64C538.18 523.64 538.18 523.64 538.18 523.64C551.56 523.64 559 523.64 560.48 523.64Z",
    id: "aEcFHS4ka"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.48 559.52C560.48 559.52 560.48 559.52 560.48 559.52C560.48 568.24 560.48 573.09 560.48 574.06C560.48 574.06 560.48 574.06 560.48 574.06C547.1 574.06 539.67 574.06 538.18 574.06C538.18 574.06 538.18 574.06 538.18 574.06C538.18 565.33 538.18 560.48 538.18 559.52C538.18 559.52 538.18 559.52 538.18 559.52C551.56 559.52 559 559.52 560.48 559.52Z",
    id: "an07jaw8h"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.58 559.52C301.58 559.52 301.58 559.52 301.58 559.52C301.58 568.24 301.58 573.09 301.58 574.06C301.58 574.06 301.58 574.06 301.58 574.06C288.19 574.06 280.76 574.06 279.27 574.06C279.27 574.06 279.27 574.06 279.27 574.06C279.27 565.33 279.27 560.48 279.27 559.52C279.27 559.52 279.27 559.52 279.27 559.52C292.65 559.52 300.09 559.52 301.58 559.52Z",
    id: "b1SODC7yPk"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.03 559.52C95.03 559.52 95.03 559.52 95.03 559.52C95.03 568.24 95.03 573.09 95.03 574.06C95.03 574.06 95.03 574.06 95.03 574.06C81.65 574.06 74.21 574.06 72.73 574.06C72.73 574.06 72.73 574.06 72.73 574.06C72.73 565.33 72.73 560.48 72.73 559.52C72.73 559.52 72.73 559.52 72.73 559.52C86.11 559.52 93.54 559.52 95.03 559.52Z",
    id: "a2xG6nr5aT"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.42 559.52C146.42 559.52 146.42 559.52 146.42 559.52C146.42 568.24 146.42 573.09 146.42 574.06C146.42 574.06 146.42 574.06 146.42 574.06C133.04 574.06 125.61 574.06 124.12 574.06C124.12 574.06 124.12 574.06 124.12 574.06C124.12 565.33 124.12 560.48 124.12 559.52C124.12 559.52 124.12 559.52 124.12 559.52C137.5 559.52 144.94 559.52 146.42 559.52Z",
    id: "d13KjU5vmX"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.18 559.52C250.18 559.52 250.18 559.52 250.18 559.52C250.18 568.24 250.18 573.09 250.18 574.06C250.18 574.06 250.18 574.06 250.18 574.06C236.8 574.06 229.37 574.06 227.88 574.06C227.88 574.06 227.88 574.06 227.88 574.06C227.88 565.33 227.88 560.48 227.88 559.52C227.88 559.52 227.88 559.52 227.88 559.52C241.26 559.52 248.69 559.52 250.18 559.52Z",
    id: "b1oaF8GELc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.94 559.52C353.94 559.52 353.94 559.52 353.94 559.52C353.94 568.24 353.94 573.09 353.94 574.06C353.94 574.06 353.94 574.06 353.94 574.06C340.56 574.06 333.12 574.06 331.64 574.06C331.64 574.06 331.64 574.06 331.64 574.06C331.64 565.33 331.64 560.48 331.64 559.52C331.64 559.52 331.64 559.52 331.64 559.52C345.02 559.52 352.45 559.52 353.94 559.52Z",
    id: "gU1mrnbYh"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.33 559.52C405.33 559.52 405.33 559.52 405.33 559.52C405.33 568.24 405.33 573.09 405.33 574.06C405.33 574.06 405.33 574.06 405.33 574.06C391.95 574.06 384.52 574.06 383.03 574.06C383.03 574.06 383.03 574.06 383.03 574.06C383.03 565.33 383.03 560.48 383.03 559.52C383.03 559.52 383.03 559.52 383.03 559.52C396.41 559.52 403.85 559.52 405.33 559.52Z",
    id: "b926wfXw"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.73 559.52C456.73 559.52 456.73 559.52 456.73 559.52C456.73 568.24 456.73 573.09 456.73 574.06C456.73 574.06 456.73 574.06 456.73 574.06C443.35 574.06 435.91 574.06 434.42 574.06C434.42 574.06 434.42 574.06 434.42 574.06C434.42 565.33 434.42 560.48 434.42 559.52C434.42 559.52 434.42 559.52 434.42 559.52C447.81 559.52 455.24 559.52 456.73 559.52Z",
    id: "b1kQExRWS2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.09 523.64C509.09 523.64 509.09 523.64 509.09 523.64C509.09 532.36 509.09 537.21 509.09 538.18C509.09 538.18 509.09 538.18 509.09 538.18C495.71 538.18 488.27 538.18 486.79 538.18C486.79 538.18 486.79 538.18 486.79 538.18C486.79 529.45 486.79 524.61 486.79 523.64C486.79 523.64 486.79 523.64 486.79 523.64C500.17 523.64 507.6 523.64 509.09 523.64Z",
    id: "c1ennvjWLP"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.79 559.52C198.79 559.52 198.79 559.52 198.79 559.52C198.79 568.24 198.79 573.09 198.79 574.06C198.79 574.06 198.79 574.06 198.79 574.06C185.41 574.06 177.97 574.06 176.48 574.06C176.48 574.06 176.48 574.06 176.48 574.06C176.48 565.33 176.48 560.48 176.48 559.52C176.48 559.52 176.48 559.52 176.48 559.52C189.87 559.52 197.3 559.52 198.79 559.52Z",
    id: "a1PVzkQKXs"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.33 523.64C405.33 523.64 405.33 523.64 405.33 523.64C405.33 532.36 405.33 537.21 405.33 538.18C405.33 538.18 405.33 538.18 405.33 538.18C391.95 538.18 384.52 538.18 383.03 538.18C383.03 538.18 383.03 538.18 383.03 538.18C383.03 529.45 383.03 524.61 383.03 523.64C383.03 523.64 383.03 523.64 383.03 523.64C396.41 523.64 403.85 523.64 405.33 523.64Z",
    id: "bDzAQ1VoE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.09 559.52C509.09 559.52 509.09 559.52 509.09 559.52C509.09 568.24 509.09 573.09 509.09 574.06C509.09 574.06 509.09 574.06 509.09 574.06C495.71 574.06 488.27 574.06 486.79 574.06C486.79 574.06 486.79 574.06 486.79 574.06C486.79 565.33 486.79 560.48 486.79 559.52C486.79 559.52 486.79 559.52 486.79 559.52C500.17 559.52 507.6 559.52 509.09 559.52Z",
    id: "bE5hv3951"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.42 595.39C146.42 595.39 146.42 595.39 146.42 595.39C146.42 604.12 146.42 608.97 146.42 609.94C146.42 609.94 146.42 609.94 146.42 609.94C133.04 609.94 125.61 609.94 124.12 609.94C124.12 609.94 124.12 609.94 124.12 609.94C124.12 601.21 124.12 596.36 124.12 595.39C124.12 595.39 124.12 595.39 124.12 595.39C137.5 595.39 144.94 595.39 146.42 595.39Z",
    id: "d1bjNY9uqq"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.58 595.39C301.58 595.39 301.58 595.39 301.58 595.39C301.58 604.12 301.58 608.97 301.58 609.94C301.58 609.94 301.58 609.94 301.58 609.94C226.52 609.94 184.82 609.94 176.48 609.94C176.48 609.94 176.48 609.94 176.48 609.94C176.48 601.21 176.48 596.36 176.48 595.39C176.48 595.39 176.48 595.39 176.48 595.39C251.54 595.39 293.24 595.39 301.58 595.39Z",
    id: "adC47WdX1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.94 595.39C353.94 595.39 353.94 595.39 353.94 595.39C353.94 604.12 353.94 608.97 353.94 609.94C353.94 609.94 353.94 609.94 353.94 609.94C340.56 609.94 333.12 609.94 331.64 609.94C331.64 609.94 331.64 609.94 331.64 609.94C331.64 601.21 331.64 596.36 331.64 595.39C331.64 595.39 331.64 595.39 331.64 595.39C345.02 595.39 352.45 595.39 353.94 595.39Z",
    id: "iBnMOBgO6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.33 595.39C405.33 595.39 405.33 595.39 405.33 595.39C405.33 604.12 405.33 608.97 405.33 609.94C405.33 609.94 405.33 609.94 405.33 609.94C391.95 609.94 384.52 609.94 383.03 609.94C383.03 609.94 383.03 609.94 383.03 609.94C383.03 601.21 383.03 596.36 383.03 595.39C383.03 595.39 383.03 595.39 383.03 595.39C396.41 595.39 403.85 595.39 405.33 595.39Z",
    id: "k2awn9wGVH"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.73 595.39C456.73 595.39 456.73 595.39 456.73 595.39C456.73 604.12 456.73 608.97 456.73 609.94C456.73 609.94 456.73 609.94 456.73 609.94C443.35 609.94 435.91 609.94 434.42 609.94C434.42 609.94 434.42 609.94 434.42 609.94C434.42 601.21 434.42 596.36 434.42 595.39C434.42 595.39 434.42 595.39 434.42 595.39C447.81 595.39 455.24 595.39 456.73 595.39Z",
    id: "a11Qy7tSvP"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.09 595.39C509.09 595.39 509.09 595.39 509.09 595.39C509.09 604.12 509.09 608.97 509.09 609.94C509.09 609.94 509.09 609.94 509.09 609.94C495.71 609.94 488.27 609.94 486.79 609.94C486.79 609.94 486.79 609.94 486.79 609.94C486.79 601.21 486.79 596.36 486.79 595.39C486.79 595.39 486.79 595.39 486.79 595.39C500.17 595.39 507.6 595.39 509.09 595.39Z",
    id: "dvOXn08Qg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.48 595.39C560.48 595.39 560.48 595.39 560.48 595.39C560.48 604.12 560.48 608.97 560.48 609.94C560.48 609.94 560.48 609.94 560.48 609.94C547.1 609.94 539.67 609.94 538.18 609.94C538.18 609.94 538.18 609.94 538.18 609.94C538.18 601.21 538.18 596.36 538.18 595.39C538.18 595.39 538.18 595.39 538.18 595.39C551.56 595.39 559 595.39 560.48 595.39Z",
    id: "a1pyGs1dnr"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bJLys9HhF",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bJLys9HhF",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b6nVrKTSeu",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b6nVrKTSeu",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#btYigjvPu",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#btYigjvPu",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a2l5mW96it",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a2l5mW96it",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c39SpFgxrA",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c39SpFgxrA",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bEpse2bm9",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bEpse2bm9",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aALNm2hVQ",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aALNm2hVQ",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d1xPb7qdj7",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d1xPb7qdj7",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e9bBF0baz",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e9bBF0baz",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b3DrgH6qBd",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b3DrgH6qBd",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#df2OInyQy",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#df2OInyQy",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b2ErcfWHv",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b2ErcfWHv",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#eOBLKPuP1",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#eOBLKPuP1",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a3KCCeju0Y",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a3KCCeju0Y",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c1oT3pAiMH",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c1oT3pAiMH",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a3liNnorv",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a3liNnorv",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cGDciW569",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cGDciW569",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b3SUCSZLE6",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b3SUCSZLE6",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f4B8mwslqD",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f4B8mwslqD",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1XuLLcX5J",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1XuLLcX5J",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a4AKAZO1MJ",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a4AKAZO1MJ",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a5dRLWWBr",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a5dRLWWBr",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a7suplbQ",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a7suplbQ",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c2JvyRf7iv",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c2JvyRf7iv",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b3xn1uhRQE",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b3xn1uhRQE",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1iuHSY2Ng",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1iuHSY2Ng",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e299QRzG69",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e299QRzG69",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1l7vNqVMC",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1l7vNqVMC",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aEcFHS4ka",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aEcFHS4ka",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#an07jaw8h",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#an07jaw8h",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1SODC7yPk",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1SODC7yPk",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a2xG6nr5aT",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a2xG6nr5aT",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d13KjU5vmX",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d13KjU5vmX",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1oaF8GELc",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1oaF8GELc",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gU1mrnbYh",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gU1mrnbYh",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b926wfXw",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b926wfXw",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1kQExRWS2",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1kQExRWS2",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c1ennvjWLP",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c1ennvjWLP",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1PVzkQKXs",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1PVzkQKXs",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bDzAQ1VoE",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bDzAQ1VoE",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bE5hv3951",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bE5hv3951",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d1bjNY9uqq",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d1bjNY9uqq",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#adC47WdX1",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#adC47WdX1",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#iBnMOBgO6",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#iBnMOBgO6",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k2awn9wGVH",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k2awn9wGVH",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a11Qy7tSvP",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a11Qy7tSvP",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dvOXn08Qg",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dvOXn08Qg",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1pyGs1dnr",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1pyGs1dnr",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatures3);
export default __webpack_public_path__ + "static/media/features-3.1e7604e99a64ddd1c51ce567980bc542.svg";
export { ForwardRef as ReactComponent };